export const UPLOAD_HISTORY_POLL_MS = 5000
export const UPLOAD_HISTORY_TAB_INDEX = 1
